<template>
  <div class="notes-list">
    <div class="note" v-if=recentFirst>
      <NoteForm ref=form :initialMarkdown="''" :commentsMode="commentsMode" @save="onCreate" v-if="recentFirst" />
    </div>
    <Note :key="note.id" v-for="note in notes" :note="note" :commentsMode="commentsMode" />
    <div class="note" v-if="!recentFirst">
      <NoteForm ref=form :initialMarkdown="''" :commentsMode="commentsMode" @save="onCreate" />
    </div>
  </div>
</template>

<script>
  import NoteForm from './NoteForm';
  import Note from './Note';
  import {showError} from 'perform-base/js/flashes';

  export default {
    props: [
      'entityType',
      'entityId',
      'recentFirst',
      'commentsMode',
    ],
    components: {
      Note,
      NoteForm
    },
    computed: {
      notes() {
        return this.recentFirst ?
               this.$store.state.notes.slice().reverse() :
               this.$store.state.notes;
      }
    },
    methods: {
      onCreate(e) {
        this.$store.dispatch('createNote', {
          entityType: this.entityType,
          entityId: this.entityId,
          markdown: e.markdown,
          files: e.files,
          type: e.noteType,
        })
            .then(() => {
              this.$refs.form.reset();
            })
            .catch((e) => {
              console.error(e);
              showError('An error occurred creating this comment. Try again later.');
            });
      },
    }
  };
</script>



// WEBPACK FOOTER //
// assets/js/components/NoteList.vue